import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["start", "end"],
    _excluded2 = ["startPoints", "endPoints", "sx", "duration", "variant", "iconSize", "preserveValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CoinsIcon } from '@infl-ts/ui-advocate-icons';
import { Box, Typography } from '@mui/material';
import CountUp from 'react-countup';
import { Translation } from 'react-i18next';
import { Tooltip } from '../tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var formatPoints = function formatPoints(points) {
  return points.toLocaleString();
};

var PointsBase = function PointsBase(_ref) {
  var sx = _ref.sx,
      iconSize = _ref.iconSize,
      children = _ref.children,
      variant = _ref.variant;
  return /*#__PURE__*/_jsxs(Box, {
    component: "span",
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      zIndex: function zIndex(t) {
        return t.zIndex._2;
      }
    },
    "data-element": "Box",
    "data-component": "PointsBase",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(CoinsIcon, {
      fontSize: iconSize,
      sx: sx,
      "data-element": "CoinsIcon",
      "data-component": "PointsBase",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(Typography, {
      component: "span",
      variant: variant,
      "data-element": "Typography",
      "data-source-file": "index.tsx",
      children: children
    })]
  });
};

export var Points = function Points(_ref2) {
  var points = _ref2.points,
      sx = _ref2.sx,
      iconSize = _ref2.iconSize,
      variant = _ref2.variant;
  return /*#__PURE__*/_jsx(PointsBase, {
    sx: sx,
    iconSize: iconSize,
    variant: variant,
    "data-element": "PointsBase",
    "data-component": "Points",
    "data-source-file": "index.tsx",
    children: formatPoints(points)
  });
};
export var PointsRange = function PointsRange(_ref3) {
  var start = _ref3.start,
      end = _ref3.end,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "PointsRange",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: start != end ? t("Earn {{startPoints}} - {{endPoints}} points", {
          startPoints: formatPoints(start),
          endPoints: formatPoints(end)
        }) : t('earnPointsText', {
          count: start
        }),
        arrow: true,
        children: /*#__PURE__*/_jsx(Box, {
          component: "span",
          sx: {
            zIndex: function zIndex(t) {
              return t.zIndex._2;
            }
          },
          children: /*#__PURE__*/_jsxs(PointsBase, _objectSpread(_objectSpread({}, props), {}, {
            children: [formatPoints(start), start != end ? " - ".concat(formatPoints(end)) : null]
          }))
        })
      });
    }
  });
};
export var AnimatedPoints = function AnimatedPoints(_ref4) {
  var startPoints = _ref4.startPoints,
      endPoints = _ref4.endPoints,
      sx = _ref4.sx,
      duration = _ref4.duration,
      variant = _ref4.variant,
      iconSize = _ref4.iconSize,
      preserveValue = _ref4.preserveValue,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return /*#__PURE__*/_jsx(PointsBase, {
    sx: sx,
    iconSize: iconSize,
    variant: variant,
    "data-element": "PointsBase",
    "data-component": "AnimatedPoints",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(CountUp, _objectSpread(_objectSpread({
      start: startPoints,
      end: endPoints || startPoints,
      duration: duration || 1.5,
      formattingFn: formatPoints,
      preserveValue: preserveValue
    }, props), {}, {
      "data-element": "CountUp",
      "data-component": "AnimatedPoints",
      "data-source-file": "index.tsx"
    }))
  });
};